import { useState,useRef } from 'react';
import { Link } from "react-router-dom";

const ItemCounter = ({ inicial, onAdd, precioo}) => {

    let lala = Number(precioo)
    const [precio, setPrecio] = useState(0)
    const preciooo = useRef(lala);
    let precioAux = precioo;
    let precioAuxiliar = 0;

console.log("preciooo",preciooo)

    const [contador, setContador] = useState(inicial);

    const sumaContador = (e) => {
        setContador(Math.min(contador + 1));

        precioAuxiliar = precioAux;
        precioAuxiliar += (precioAux * contador);
        setPrecio(precioAuxiliar);

        preciooo.current = preciooo.current + precioo
        console.log("preciooo",preciooo)
    }

    const restaContador = (e) => {
        setContador(Math.max(inicial, contador - 1));

        setPrecio(Math.max(precioAux, precio - precioAux))
        preciooo.current = preciooo.current - precioo
        console.log("preciooo",preciooo)
    }

    const enviarCarrito = (e) => {
        onAdd(contador);
    }
    let signoPeso = "$"
    return (
        <div className='unidades-contador-btn'>
            <h3>Unidades</h3>
            <div className='contador'>

                <div className='contador-btns'>
                    <button className="btn-contador" onClick={restaContador}>
                        <img src='/img/resta.png' className='suma-resta' />
                    </button>
                    <span className="contador-cantidad">{contador}</span>
                    <button className="btn-contador" onClick={sumaContador}>
                        <img src='/img/suma.png' className='suma-resta' />
                    </button>
                </div>
                <span className='precio-contador'>{signoPeso}{precio == 0 ? precioAux : precio}</span>
            </div>
            <Link to="/" className='btn-agregar-link'>
                <button className="btn-agregar-carrito" onClick={enviarCarrito}>
                    Agregar al carrito
                </button>
            </Link>
        </div>
    )
}

export default ItemCounter;